import React from 'react';

import {
  InvestmentGeographyName,
  useInvestmentGeographySelectFieldQuery as useBaseQuery
} from 'generated/graphql';
import _ from 'lodash';
import { fields } from 'modules/layer2';



export function useInvestmentGeographySelectField() {
  const tuple = useBaseQuery();

  return React.useMemo(() => {

    const parentNames = new Set(_.compact(_.map(tuple.data?.investmentGeographies, geo => geo.parentName)));

    return {
      ...tuple,
      data: {
        enumValues: _.map(tuple.data?.investmentGeographies ?? [], (geo): fields.IGroupedOption<InvestmentGeographyName> => ({
          id: geo.id,
          label: geo.displayName,
          parentName: geo.parentName || null,
          ranking: geo.ranking,
          isLeaf: !parentNames.has(geo.name),
          displayName: geo.displayName,
          name: geo.name
        }))
      }
    };
  }, [tuple]);
}
